import axios from '@/plugins/axios'

const getLists = async ({ contentType = null, contentId = null, type = null, page = 1 }) => {
  const params = {}
  if (contentType === 'book') params.book_id = contentId
  else if (contentType === 'post') params.post_id = contentId
  if (type) params.type = type
  params.page = page
  try {
    const response = await axios.get('lists', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getHomeLists = async ({ page = 1 }) => {
  const params = {}
  params.page = page
  params.is_home = 1
  try {
    const response = await axios.get('lists', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getList = async slug => {
  try {
    const response = await axios.get(`lists/${slug}`)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const postList = async (id = null, { name, visibility, description = null, slug = null, type = 'list', cover = null }) => {
  try {
    const form = new FormData()
    form.append('name', name)
    form.append('visibility', visibility)
    form.append('type', type)
    if (description) form.append('description', description)
    if (slug) form.append('slug', slug)
    if (cover) form.append('cover', cover)
    if (id) form.append('_method', 'PUT')
    const url = id ? `lists/${id}` : 'lists'
    const response = await axios.post(url, form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const destroy = async id => {
  try {
    const response = await axios.post(`lists/${id}`, {
      _method: 'DELETE'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const toggleContentToList = async (listId, action, { contentType = null, contentId = null }) => {
  const params = {
    list_id: listId
  }
  if (action === 'add') params._method = 'PUT'
  else if (action === 'remove') params._method = 'DELETE'

  if (contentType === 'book') params.book_id = contentId
  else if (contentType === 'post') params.post_id = contentId
  try {
    const response = await axios.post('lists/content', params)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getContent = async ({ listId, page = 1 }) => {
  try {
    const params = {
      list_id: listId,
      page: page
    }
    const response = await axios.get('lists/content', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const destroyMultipleContents = async (id, contents) => {
  try {
    const response = await axios.post('lists/content', {
      _method: 'DELETE',
      list_id: id,
      content: contents
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  destroy,
  getContent,
  getLists,
  getHomeLists,
  getList,
  postList,
  toggleContentToList,
  destroyMultipleContents
}
